import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";
import { ActiveComponentCard } from "./ActiveComponentCard";
import type { ConfigComponent } from "./types";

interface SortableComponentCardProps {
  component: ConfigComponent;
  onRemove: () => void;
  onQuantityChange: (quantity: number) => void;
  onMaterialChange: (materialId: string) => void;
  onDimensionChange: (dimension: 'width' | 'height' | 'thickness', value: number | null) => void;
  onAttributeChange: (attributeId: string, value: string | number | null) => void;
}

export function SortableComponentCard({
  component,
  onRemove,
  onQuantityChange,
  onMaterialChange,
  onDimensionChange,
  onAttributeChange
}: SortableComponentCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: component.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`relative ${isDragging ? 'z-50 opacity-90' : ''}`}
    >
      {/* Drag handle overlay */}
      <div
        {...attributes}
        {...listeners}
        className="absolute left-0 top-0 bottom-0 w-8 flex items-center justify-center cursor-grab active:cursor-grabbing z-10 hover:bg-muted/50 rounded-l-lg transition-colors"
      >
        <GripVertical className="h-5 w-5 text-muted-foreground" />
      </div>
      
      {/* Card with left padding for drag handle */}
      <div className="pl-8">
        <ActiveComponentCard
          component={component}
          onRemove={onRemove}
          onQuantityChange={onQuantityChange}
          onMaterialChange={onMaterialChange}
          onDimensionChange={onDimensionChange}
          onAttributeChange={onAttributeChange}
        />
      </div>
    </div>
  );
}
